import React from 'react';
import styles from '../LandingPage.module.css';
import extraStyles from '../LandingPageExtras.module.css';

const TestimonialsSection = () => {
  const testimonials = [
    {
      quote: "Provaantech helped us accelerate our digital initiatives by rapidly assembling a highly skilled engineering team. Their execution quality and responsiveness exceeded expectations.",
      author: "Enterprise Technology Client"
    },
    {
      quote: "The combination of AI-driven hiring through Prohirey and technical delivery expertise significantly reduced our onboarding timelines.",
      author: "GCC Operations Leader"
    },
    {
      quote: "Their ability to support enterprise technologies and AI innovation makes them a valuable long-term technology partner.",
      author: "Global Business Executive"
    }
  ];

  return (
    <div className={styles.lightSection}>
      <div className={styles.section} style={{ paddingTop: '40px' }}>
        <div className={styles.pillLight}>🔹 Client Success Stories</div>
        <h2 className={styles.sectionTitleLight}>Trusted by businesses building the<br/>future</h2>
        
        <div className={extraStyles.testimonialsGrid}>
          {testimonials.map((test, index) => (
            <div key={index} className={extraStyles.testimonialCard}>
              <div className={extraStyles.quoteIcon}>"</div>
              <div className={extraStyles.testimonialText}>{test.quote}</div>
              <div className={extraStyles.testimonialAuthor}>— {test.author}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TestimonialsSection;
